
import { supabase } from "@/integrations/supabase/client";
import { Tables } from "@/integrations/supabase/types";
import { toast } from "sonner";
import { fetchAllSuggestionsRaw } from "./rawFetch";

/**
 * Fetches suggestions from Supabase using the standard approach
 * @param setSuggestions - State setter function for suggestions
 * @returns Promise that resolves when the operation is complete
 */
export const fetchSuggestionsFromSupabase = async (
  setSuggestions: (suggestions: Tables<'suggestions'>[]) => void
): Promise<void> => {
  try {
    console.log('Fetching ALL suggestions from Supabase...');
    
    // Make sure we fetch all fields and sort by created_at
    const { data, error } = await supabase
      .from('suggestions')
      .select('*')
      .order('created_at', { ascending: false });

    console.log('Raw Supabase query result:', { data, error });

    if (error) {
      console.error('Detailed Supabase query error:', error);
      toast.error('Kunne ikke hente tips. Feil ved databaseforespørsel.');
      
      // Try fallback method
      await fetchAllSuggestionsRaw(setSuggestions);
      return;
    }

    // If we get data (even an empty array), set the state
    if (data) {
      console.log('Suggestions retrieved:', data);
      console.log('Number of suggestions:', data.length);
      
      if (data.length > 0) {
        // Log each suggestion's details
        data.forEach((suggestion, index) => {
          console.log(`Suggestion ${index + 1}:`, {
            id: suggestion.id,
            message: suggestion.message,
            senderName: suggestion.sender_name,
            senderEmail: suggestion.sender_email,
            createdAt: suggestion.created_at
          });
        });
        
        setSuggestions(data);
      } else {
        console.log('No suggestions fetched, trying RPC method...');
        await fetchAllSuggestionsRaw(setSuggestions);
      }
    } else {
      console.warn('No data returned from suggestions query');
      await fetchAllSuggestionsRaw(setSuggestions);
    }
  } catch (error) {
    console.error('Comprehensive error in fetchSuggestionsFromSupabase:', error);
    toast.error('Kunne ikke hente tips. En uventet feil oppstod.');
    
    // Try fallback method
    await fetchAllSuggestionsRaw(setSuggestions);
  }
};
